export default __webpack_public_path__ + "static/media/Logo.74a31057.svg";